<div class="holder">
  <ul>
    <li *ngFor="let item of data" [ngClass]="{ active: item.active }">
      <span *ngIf="!item.href">{{ item.name }}</span>
      <a *ngIf="item.href" [href]="item.href">{{ item.name }}</a>
    </li>
  </ul>
</div>
